// FIlename: LoginScreen.tsx
//
// Component: LoginScreen
//
// Purpose:
// Build and render the login screen so that users are allowed to log in
// gets the user data input into fields and verifies database to ensure
// user has an account and retrieve user data to render next screen
//
// What this file does:
// - Uses previously built custom components to build the login screen
// - Calls the database to verify user exists and information is correct
// - Redirects user to next screen if login is successfull or return an error if no user
// with that information is found

import Button from "../Button/Button"; // Custom Button component
import TextField from "../TextField/TextField"; // Custom TextField component
import HomeButton from "../HomeButton/HomeButton"; // Custom HomeButton component
import { Grid, Link, Typography } from "@mui/material"; // MUI components import
import { useLoginScreenStyles } from "./LoginScreenStyles"; // Style hook for sx styling
import GMHutBackground from "./GMHutBackground.png"; // Background image import

// Login screen page
const LoginScreen = () => {
  const { classes } = useLoginScreenStyles();

  const alertForAccessKey = () => {
    alert(
      "GMHut is not available for the public yet! Please request an access key",
    );
  };

  return (
    <Grid className={classes.outerContainer}>
      <Grid className={classes.homeButtonContainer}>
        <HomeButton onClick={() => {}} />
      </Grid>
      <img alt="Background" src={GMHutBackground} className={classes.image} />
      <Grid className={classes.loginSection}>
        <Grid className={classes.logo}>
          <img src="https://i.imgur.com/CGQOSWU.png" alt="GM HUT Logo" />
          <Typography variant="h1">GM HUT</Typography>
        </Grid>
        <Grid className={classes.textFieldsContainer}>
          <TextField
            label="Username"
            onChange={(value) => console.log(value)}
          />
          <Grid className={classes.passwordFieldAndForgotPassword}>
            <TextField
              label="Password"
              onChange={(value) => console.log(value)}
              password
            />
            <Link
              variant="subtitle2"
              onClick={alertForAccessKey}
              href="#"
              className={classes.forgotPassword}
            >
              Forgot Password
            </Link>
          </Grid>
        </Grid>
        <Grid className={classes.buttonAndCreateAccount}>
          <Button variant="contained" onClick={alertForAccessKey}>
            Login
          </Button>
          <Grid className={classes.createAccount}>
            <Typography variant="subtitle2">Don't have an account?</Typography>
            <Link href="#" onClick={alertForAccessKey} variant="subtitle2">
              {" "}
              CREATE ACCOUNT{" "}
            </Link>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default LoginScreen;
